import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { requestGet } from '../../api/request';
import { STRUCTURES } from '../../api/url';
import * as actions from '../../redux/actions';

const Head = () => {
  const dispatch = useDispatch();
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);
  const [data, setData] = useState([]);

  const getData = async () => {
    const response = await requestGet(STRUCTURES, {
      'lang_id': currentLanguage.id,
      'structure_type_name': 'head_of_government',
    });

    if (response.success) {
      setData(response.data);
    }
  };
  const newStyle = () => {
    const select = document.querySelectorAll('.page-content *');
    for (let i = 0; i < select.length; i += 1) {
      const elem = select[i];
      elem.style.fontFamily = 'PT Sans Narrow Regular';
    }
  };

  useEffect(() => {
    getData();
  }, [dictionary]);

  useEffect(() => {
    if (data) {
      dispatch(actions.adjustFontSize(fontSize));
      newStyle();
    }
  });

  return (
    <div
      className="tab-pane fade show active"
      id="chief"
      role="tabpanel"
      aria-labelledby="chief-tab"
    >
      {typeof data !== 'undefined' && data !== null ? (
        <div className="page-content">
          <div dangerouslySetInnerHTML={{ __html: data.text }} />
        </div>
      ) : null}
    </div>
  );
};

export default Head;
